module.exports = __webpack_public_path__ + "static/media/Pangram-Black.525dc9cb.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Pangram-Black.otf
// module id = 703
// module chunks = 0